// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable import/prefer-default-export */
import { dateFormatter, formatDate, getESTDateTime } from '@tcp/core/src/utils/utils';
import {
  getMapSliceForColor,
  getMapSliceForSize,
} from '../../../browse/ProductListingPage/util/utility';

const getImgUrl = (imagesByColor, color) =>
  (imagesByColor &&
    imagesByColor[color] &&
    (imagesByColor[color].basicImageUrl ||
      (imagesByColor[color].extraImages[0] || {}).iconSizeImageUrl)) ||
  '';
const getAttributeFromCurrentSize = (currentSizeEntry) => {
  return {
    skuId: currentSizeEntry?.skuId,
    variantId: currentSizeEntry?.variantId,
    variantNo: currentSizeEntry?.variantNo ? currentSizeEntry.variantNo : null,
    prodPartNo: currentSizeEntry?.prodPartNo ? currentSizeEntry.prodPartNo : null,
    offerPrice: currentSizeEntry?.offerPrice || '',
    listPrice: currentSizeEntry?.listPrice || '',
  };
};

const getListPricing = (currentSizeEntry) => (currentSizeEntry && currentSizeEntry.listPrice) || 0;

const getPreOrderDate = ({ currentColorEntry, currentSizeEntry, size }) => {
  const today = getESTDateTime();
  const selectedVariantVariant = currentSizeEntry?.variantId ? currentSizeEntry.variantId : null;
  let itemPreOrderDate = '';
  if (selectedVariantVariant && currentColorEntry.miscInfo?.variantPreOrderMap?.length) {
    currentColorEntry.miscInfo?.variantPreOrderMap.forEach((ele) => {
      if (ele.variant === selectedVariantVariant && ele.size === size) {
        itemPreOrderDate = ele.preOrderDate;
      }
    });
  }
  let preOrderDate = itemPreOrderDate || currentColorEntry?.miscInfo?.preOrderDate || '';
  const variantPreOrderDate = dateFormatter(preOrderDate);
  preOrderDate =
    Date.parse(today) > Date.parse(variantPreOrderDate) ? formatDate(today) : preOrderDate;
  return preOrderDate;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const getCartItemInfo = (productInfoOrWishlistItem, customizationInfo, fromFBT) => {
  let obj = {};
  if (productInfoOrWishlistItem.productInfo) {
    // productInfoOrWishlistItem is a wishlistItem

    const {
      productInfo: { name, isGiftCard, TCPStyleType, TCPStyleQTY, TCPMultipackProductMapping },
      skuInfo,
      itemInfo,
    } = productInfoOrWishlistItem;
    obj = {
      isGiftCard,
      productName: name,
      skuInfo,
      quantity: 1,
      itemId: itemInfo.itemId || '',
      TCPStyleType,
      TCPStyleQTY,
      TCPMultipackProductMapping,
    };
  } else {
    // productInfoOrWishlistItem is a productInfo
    const {
      fit = '',
      size,
      quantity = 1,
      isBoss,
      storeLocId,
      brand,
      styleType,
    } = customizationInfo;

    let { color } = customizationInfo;
    const { name, colorFitsSizesMap, isGiftCard, imagesByColor, varientCount, seoToken } =
      productInfoOrWishlistItem;
    let imageUrl = getImgUrl(imagesByColor, color);
    let formPartNumber; // This is only defined in case of multiple colors with same name
    if (!isGiftCard && color) {
      [color, formPartNumber] = color && color.split('-');
      if (!imageUrl) {
        imageUrl = getImgUrl(imagesByColor, color);
      }
    }
    const currentSizeEntry = getMapSliceForSize(
      colorFitsSizesMap,
      color,
      fit,
      size,
      fromFBT,
      formPartNumber
    );
    const currentColorEntry = getMapSliceForColor(colorFitsSizesMap, color, formPartNumber);
    const preOrderDate = getPreOrderDate({ currentColorEntry, currentSizeEntry, size });

    const {
      isClearance,
      isOnline,
      tcpStyleType,
      tcpStyleQty,
      mprLoyaltyMultiplier,
      plccLoyaltyMultiplier,
      variantPreOrderMap,
    } = currentColorEntry?.miscInfo || {};
    obj = {
      isGiftCard,
      productName: name,
      skuInfo: {
        imageUrl,
        color: currentColorEntry?.color,
        unbxdProdId: productInfoOrWishlistItem.unbxdProdId,
        productId: productInfoOrWishlistItem.generalProductId,
        fit,
        size,
        ...getAttributeFromCurrentSize(currentSizeEntry),
        TCPWebOnlyFlagStore: isOnline,
        TCPStyleType: tcpStyleType || styleType,
        TCPStyleQTY: tcpStyleQty,
        productFamily: productInfoOrWishlistItem.productFamily,
        TCPMultipackProductMapping: productInfoOrWishlistItem.TCPMultipackProductMapping,
        TCPProductIndStore: isClearance,
        LoyaltyPromoMultiplierStore: mprLoyaltyMultiplier,
        LoyaltyPromoPLCCMultiplierStore: plccLoyaltyMultiplier,
        productPartNoOfCurrentColor: formPartNumber,
        preOrderDate,
        listPrice: getListPricing(currentSizeEntry),
        variantPreOrderMap,
        seoToken: currentColorEntry?.pdpSeoUrl || seoToken,
      },
      hardMarkDown: currentColorEntry?.hardMarkDown,
      TCPPromotionID: currentColorEntry?.TCPPromotionID,
      quantity: quantity || 1,
      isBoss,
      storeLocId,
      brand,
      wishlistItemId:
        customizationInfo.wishlistItemId ||
        (productInfoOrWishlistItem.itemInfo && productInfoOrWishlistItem.itemInfo.itemId),
      isOnlineExclusive: colorFitsSizesMap
        ? colorFitsSizesMap[0]?.miscInfo?.badge1?.defaultBadge
        : null,
      varientCount,
      bigIdeaLicensedProductBrand: currentColorEntry?.bigIdeaLicensedProductBrand,
    };
  }
  return obj;
};

export const shouldRenderPoints = (
  isSuppressGetOrderDetails,
  isAvoidGetOrderDetails,
  pointsSummary,
  isATBHidePoints,
  isLoyaltyPointsEnabled
) =>
  (!isSuppressGetOrderDetails || isAvoidGetOrderDetails) &&
  Object.keys(pointsSummary).length !== 0 &&
  !isATBHidePoints &&
  isLoyaltyPointsEnabled;
